import React, { FC } from 'react';

export const TermsOfUse: FC = () => {
  return (
    <div className="terms-of-use center">
      <h1>Terms of Use</h1>
      <p>&emsp;Last revised: June 21, 2021 </p>
      <p>&emsp;Welcome to swap.kiwi! We are currently in beta version.</p>
      <p>
        &emsp;swap.kiwi is a platform that allows you to swap non-fungible tokens (NFTs) with other users on the
        Ethereum network. swap.kiwi is not a party to any agreement between the owners of NFTs or between any users.
        This website is only an interface allowing participants to facilitate transactions in form of a barter to
        exchange digital collectibles between two users.
      </p>
      <p>
        &emsp;swap.kiwi has no responsibility for the NFTs swapped by users on swap.kiwi. swap.kiwi does not investigate
        and cannot guarantee or warrant the authenticity, originality, uniqueness, marketability, legality or value of
        any NFT swapped between users on swap.kiwi. You agree and understand that you access and use swap.kiwi at your
        own risk.
      </p>
      <p>
        &emsp;Users are entirely responsible for the safety and management of their own private Ethereum wallets and
        validating all transactions and contracts generated by this website before approval. The swap.kiwi smart
        contract runs on the Ethereum network, meaning that there is no ability to reverse, undo or restore a
        transaction.
      </p>
      <p>
        &emsp;Swapping NFTs is subject to fees. Fees include: (a) service fee established by and payable to swap.kiwi;
        and (b) “gas” (fees paid to Ethereum miners in ETH through users’ independent wallet applications as
        consideration for mining the users’ transactions).
      </p>
      <p>
        &emsp;This website, content contained therein, NFTs listed and its connected services are provided on an “as is”
        and “as available” without warranty of any kind. By using this website you are accepting sole responsibility for
        transactions involving your digital collectibles.
      </p>
    </div>
  );
};
